import Fragment from "../../football/fragments/fragment";
import FragmentDataType from "../../football/enums/fragment-data-type";
import FragmentSummary from "../../football/fragments/fragment-summary";
import { getFieldDirectionMultiplier } from "../../football/utils/context-utils";

export default class FlagPatTry extends Fragment {
    constructor(points) {
        super();

        this.points = points;
        this.requiredData = [
            {
                name: "points",
                type: FragmentDataType.PatPoints,
                displayName: "PAT Points",
                title: "PAT Points",
                subtitle: "Select the scoring points",
                isEditable: true
            }
        ];
    }

    getPatSpotDistance(gameConfig, patPointsOption) {
        const { spots } = gameConfig;
        const patSpots = [
            0,
            spots.spotsPatScoreOption1,
            spots.spotsPatScoreOption2,
            spots.spotsPatScoreOption3
        ];

        return patSpots[patPointsOption.code];
    }

    // eslint-disable-next-line no-unused-vars
    summarize(summaryContext, stringifier) {
        return new FragmentSummary("", "PAT:");
    }

    updateSummaryContext(summaryContext, play) {
        summaryContext.sopPrinted = true;
        summaryContext.isPatPlay = true;
        summaryContext.down = 1;
        summaryContext.patPoints = 0;
        if (this.points) {
            summaryContext.patPoints = this.points.value;

            const distance = this.getPatSpotDistance(
                summaryContext.gameConfig,
                this.points.option
            );

            if (getFieldDirectionMultiplier(summaryContext) < 0) {
                summaryContext.firstDownAt = 0;
                summaryContext.fieldPosition = distance;
            } else {
                summaryContext.firstDownAt =
                    summaryContext.gameConfig.general.fieldLength;
                summaryContext.fieldPosition =
                    summaryContext.gameConfig.general.fieldLength - distance;
            }
        }
    }

    getScoringPoints() {
        return this.points.value || 0;
    }
}
